// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StylesGuideH1 {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 1px;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Titles/H1/H1.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ","sourcesContent":[".StylesGuideH1 {\n    font-size: 30px;\n    font-weight: 600;\n    letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
